import React from "react";
// import "./orderTable.css";
import "./table.css";
import styled from "@emotion/styled";

export const TableContainer = styled("div")(
  {
    background: "#ffffff",
    border: "1px solid #e7e5ff",
    borderRadius: "15px",

    maxWidth: "50rem",
    height: "28rem",
    overflowY: "scroll",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

export const TableFooter = styled("div")(
  {
    background: "#2AD3E7",
    border: "1px solid #e7e5ff",
    borderBottomLeftRadius: " 15px",
    borderBottomRightRadius: "15px",
    maxWidth: "45rem",
    height: "3rem",
  },
  (props) => ({
    maxWidth: props.maxWidth,
  })
);

const SendMailCFATable = ({ maxWidth = "60rem" }) => {
  return (
    <div className="">
      <TableContainer maxWidth={maxWidth}>
        <table className="main-table">
          <tr className="table-rows">
            <th className="table-heads text-dark " width={"2%"}>
              #
            </th>
            <th className="table-heads text-dark" width={"11%"}>
              Product Name
            </th>
            <th className="table-heads text-dark" width={"4%"}>
              Qty
            </th>
            <th className="table-heads text-dark" width={"4%"}>
            Price
            </th>
            <th className="table-heads text-dark" width={"8%"}>
            Required Qty
            </th>
            
          </tr>
          <tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr><tr className="table-rows1">
            <td className="table-each-row-data color_747f9e">1</td>
            <td className="table-each-row-data color_747f9e">
              Product Name goes here
            </td>
            <td className="table-each-row-data color_747f9e">1000</td>
            <td className="table-each-row-data color_747f9e">₹ 250.00</td>
            <td className="table-each-row-data color_747f9e">
              100
            </td>            
          </tr>
         
        </table>
      </TableContainer>
    </div>
  );
};

export default SendMailCFATable;
